/* src/app/shared/footer/footer.component.scss */
.elanco-bg-bottom {
  width: 100%;
  height: 49px;
  position: absolute;
  left: 0px;
  bottom: 0px;
}
.elanco-powered-right {
  width: 400px;
  position: absolute;
  right: 15px;
  bottom: 23px;
}
.copyright[data-tool=Swine] {
  color: #8f8f8f;
  left: 10px;
  bottom: calc(37px - 0.178vw);
}
.copyright {
  font: normal normal 11px/11px arial;
  position: absolute;
}
.bottom {
  position: fixed;
  bottom: 0;
  width: 100%;
}
.bot_bg {
  height: 49px;
}
img {
  vertical-align: middle;
  border: none;
  position: fixed;
}
/*# sourceMappingURL=footer.component-6ZB6YHCH.css.map */
